
<div class="notification-card">
  <div class="notification-header">
    <div class="notification-header-accent">
      WordFlight Notification
      <div>
        <div class="notification-header-close" (click)="handleClose()">X</div>
      </div>
    </div>
    <div class="notification-header-title" [innerHTML]="headerTitle()"></div>
  </div>

  <div class="body">
    @for (paragraph of preambles(); track $index) {
      <p class="intro"
         [style.font-weight]="paragraph.isSubheading ? '700' : null"
         [style.color]="paragraph.isSubheading ? '#0054A6' : null"
         [innerHTML]="paragraph.text"></p>
    }

    @if(usageHighlight()) {
      <div style="background:#f3faeb;border:1px solid #80C342;border-radius:10px;padding:14px 18px;margin-bottom:18px;display:flex;align-items:center;gap:14px;">
        <div style="font-size:32px;font-weight:700;color:#007236;">{{ usageHighlight() }}</div>
        <div>
          <div style="font-size:14px;font-weight:700;color:#007236;">students hit their 60&ndash;80 min goal last week</div>
          <div style="font-size:13px;color:#444;margin-top:2px;">That&rsquo;s worth celebrating &mdash; let them know!</div>
        </div>
      </div>
    }

    <!-- content projection for more specific detailed notifications -->
    <div class="table-scroll-container">
      <ng-content select="[table]"></ng-content>
    </div>

    <div class="steps">
      @for (step of steps(); track $index) {
        <div class="step" [class.step-green]="step.variant === 'green'" [class.step-warn]="step.variant === 'warn'">
          <div class="num" [class.num-green]="step.variant === 'green'" [class.num-warn]="step.variant === 'warn'">
            {{ $index + 1 }}
          </div>
          <div>
            <div class="step-title" [class.step-title-green]="step.variant === 'green'" [class.step-title-warn]="step.variant === 'warn'">
              {{ step.title }}
            </div>
            <div class="step-body" [innerHTML]="step.body | safeHtml"></div>
          </div>
        </div>
      }
    </div>

    @if (ctaRoute()) {
      <div>
        <a href="#" class="cta" [attr.data-route]="ctaRoute()" (click)="handleRouteClick($event)">{{ ctaLabel() }} &rarr;</a>
      </div>
    }

    @if (closingText()) {
      <p class="closing" [innerHTML]="closingText()"></p>
    }

    @if (canDismiss()) {
      <div>
        <button class="btn btn-dismiss float-end" (click)="handleDismiss()"><fa-icon [icon]="dismissIcon"></fa-icon> Dismiss</button>
      </div>
    }
  </div>

  <div class="support">
    Questions or need support? Call <a href="tel:8887013009">888-701-3009</a> or email
    <a href="mailto:customerservice@foundations-learning.com">customerservice&#64;foundations-learning.com</a>
  </div>
</div>
